(function (angular) {
    // Determines whether an input element contains a valid credit card expiration date
    angular.module('app').directive('creditCardExpiration', function () {
            return {
                require: 'ngModel',
                link: function (scope, elem, attrs, ctrl) {
                    elem.on('change', function () {

                        var date = moment(this.value, 'MM/YY');

                        ctrl.$setValidity('valid', date._isValid && date.diff(moment(), 'months') >= 0);

                        ctrl.$setTouched();

                        // apply changes on scope
                        scope.$apply();
                    });
                }
            };
        }
    );
})(angular);